import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import stopListColumns from '../../../components/RouteDetail/StopList/stopListColumns';
import { getSortedStops } from '../../../store/selectors/ui/routeDetail';
import { getRouteDetail } from '../../../store/selectors/route';
import { stopListColumnsConfigs } from '../../../enums/columnsConfigs';

const useStopListTableProps = (
  modifiers,
  headerCellClasses,
  bodyCellClasses
) => {
  const route = useSelector(getRouteDetail);
  const sortedStops = useSelector(getSortedStops);

  const columns = useMemo(
    () =>
      stopListColumns({
        route,
        modifiers,
        columnsConfigs: stopListColumnsConfigs,
        headerCellClasses,
        bodyCellClasses,
      }),
    [modifiers, route, headerCellClasses, bodyCellClasses]
  );

  const tableWidth = useMemo(
    () =>
      columns.reduce(
        (acc, column) => acc + (column?.columnConfig?.width || 0),
        0
      ),
    [columns]
  );

  return {
    columns,
    data: sortedStops,
    tableWidth,
  };
};

export default useStopListTableProps;
